// extracted by mini-css-extract-plugin
export default {"employee-container":"MidMonthPay_employee-container__VMs02","mid-month-header":"MidMonthPay_mid-month-header__2J8fq"};